import { AfterViewInit, Component, computed, inject } from '@angular/core';
import {
  BuildingFilterDto,
  EquipmentFilterDto,
  EquipmentItemDto,
  EquipmentService,
  TenantDetailDto,
} from '@artemis-software/wr-api';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CurrentUserService } from '@services/current-user.service';
import { catalogReadOnlyBanner, catalogTenantId, isCatalogReadOnly } from '@/utils/admin-utils';

@Component({
  standalone: false,
  selector: 'wr-tga-type-overview-page',
  templateUrl: './tga-type-overview-page.component.html',
  styleUrls: ['./tga-type-overview-page.component.scss'],
})
export class TgaTypeOverviewPageComponent implements AfterViewInit {

  private readonly router = inject(Router);
  private readonly equipmentService = inject(EquipmentService);
  private readonly currentUserService = inject(CurrentUserService);
  private readonly fb = inject(FormBuilder);
  protected readonly BuildingFilterDto = BuildingFilterDto;
  protected readonly TenantTypeEnum = TenantDetailDto.TypeEnum;

  readonly form: FormGroup;

  canCreate = computed(() => this.currentUserService.hasPrivilege('canCreateTgaTypes'));
  readonly catalogReadOnly = isCatalogReadOnly();
  readonly catalogBanner = catalogReadOnlyBanner();
  readonly tenantId = catalogTenantId();

  readonly loadEquipments = (filter: EquipmentFilterDto) => this.equipmentService.findAll(filter);
  readonly getCount = (filter: EquipmentFilterDto) => this.equipmentService.getCount(filter);

  constructor() {
    this.form = this.fb.group({
      text: [''],
      tenantId: [this.tenantId() ?? null],
      deprecated: [false],
      facilityElement: [null],
    });
  }

  navigateToTgaType(equipment: EquipmentItemDto): void {
    this.router.navigate(['equipment', equipment.id]);
  }

  add(): void {
    this.router.navigate(['equipment', 'new']);
  }

  getIcon(equipment: EquipmentItemDto): string {
    return equipment.icon?.presignedUrl ?? '';
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.form.patchValue(this.form.value);
    });
  }
}
